import React from 'react';
import { patch } from './frontlineDemo';
import { VoiceNote } from './VoiceNote';

// "Something else" barrier: a short written or spoken note that Maya sees with the request.
export const BarrierNote = ({ s }) => (
  <VoiceNote value={s.barrierNote} onSave={(barrierNote) => patch({ barrierNote })} label="What's in the way?" hint="a sentence is plenty — Maya sees this with your request" placeholder="e.g. The test port on this unit is a different fitting to the one I trained on" testId="fl-barrier-note" />
);
